import API from '../services/api';

const api = new API();

const URL_GOALS_LIST = '/goals/list';
const URL_COST_CURRENCY = '/goals/get_cost_currency';
const URL_USER_FILTERS = '/goals/user_filters';
const URL_GOAL_DETAILS = '/goals/goal_details';
const URL_GOAL_SAVE = '/goals/api';
const URL_GOAL_DELETE = '/goals/delete';

const unwrap = response => {
    if (!response || response.status !== 0) {
        return Promise.reject(response && response.value);
    }
    return response.value;
};

export class GoalConflictError extends Error {}

export function fetchGoals() {
    return api
        .getJson(URL_GOALS_LIST, { method: 'GET', credentials: 'include', cache: false, forceRefresh: true })
        .then(unwrap);
}

export function invalidateGoalsListCache() {
    api.invalidate(URL_GOALS_LIST);
    api.invalidate(`${URL_GOALS_LIST}?include_metric=true`);
}

export function fetchCostCurrency() {
    return api
        .getJson(URL_COST_CURRENCY, { method: 'GET', credentials: 'include', cache: false })
        .then(unwrap)
        .then(value => (value && value.symbol) || '');
}

// RawJsonResponse - no {status, value} envelope.
export function fetchGoalFilters() {
    return api
        .getJson(URL_USER_FILTERS, {
            method: 'GET',
            credentials: 'include',
            cache: false,
            params: { with_data: true },
        })
        .then(response => {
            if (response && response.status === 1) {
                return Promise.reject(response.value);
            }
            return (response && response.filters) || [];
        });
}

export function fetchGoalDetails(goalId) {
    return api
        .getJson(URL_GOAL_DETAILS, { method: 'GET', credentials: 'include', cache: false, params: { id: goalId } })
        .then(unwrap);
}

export function saveGoal(payload) {
    return api.getJson(URL_GOAL_SAVE, { method: 'POST', credentials: 'include', body: payload }).then(response => {
        if (response && response.status === 1) {
            throw new GoalConflictError(response.value);
        }
        return unwrap(response);
    });
}

export function deleteGoal(goalId) {
    return api
        .getJson(URL_GOAL_DELETE, { method: 'POST', credentials: 'include', params: { id: goalId } })
        .then(response => {
            if (!response || response.status !== 0) {
                return Promise.reject(response && response.value);
            }
            return response.value;
        });
}
